export const CLASS_DETAIL_ROUTE = '/classes';
